import { Grid, Typography, ButtonBase, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import soluciones from "../../Data/soluciones.json";
import { Helmet } from "react-helmet-async";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";

const Seccion_Servicio_Enfoque = () => {
    const { categoria, servicio } = useParams();
    const { sCell } = useResponsive();
    const navigate = useNavigate();

    const slug = servicio
        ? `/servicios/${categoria}/${servicio}/`
        : `/servicios/${categoria}/`;

    let servicioEncontrado = null;

    soluciones.forEach(padre => {
        const found = padre.servicios?.find(s => s.slug === slug);
        if (found) servicioEncontrado = found;
    });

    if (!servicioEncontrado) {
        servicioEncontrado = soluciones.find(s => s.slug === slug);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);

    if (!servicioEncontrado) {
        return (
            <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '50vh', pt: 20 }}>
                <Typography variant="h6">Servicio no encontrado</Typography>
                <Grid container justifyContent="center" sx={{ mt: 2 }}>
                    <Link to="/servicios/" style={{ textDecoration: 'none', color: '#223B59', fontWeight: 600 }}>
                        Volver a servicios
                    </Link>
                </Grid>
            </Grid>
        );
    }

    return (
        <>
            <Helmet>
                <title>{servicioEncontrado.title} en Cali | Espacio Compacto</title>
                <meta name="description" content={servicioEncontrado.metaDescripcion} />
                <meta name="keywords" content={servicioEncontrado.keywords?.join(", ")} />
                <link rel="canonical" href={`https://espaciocompacto.com${servicioEncontrado.slug}`} />
            </Helmet>

            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12 }}
                sx={{ px: 3, pt:sCell?12:20, pb: sCell?0:8 }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    size={{ xs: 12, sm: 12, md: 10 }}
                    sx={{ }}
                >
                    <Grid container justifyContent="center" alignItems="center" size={{ xs: 12 }}>

                        {/* ── HERO ── */}
                        <Grid
                            container
                            justifyContent="space-between"
                            alignItems="flex-start"
                            size={{ xs: 12 }}
                            sx={{ borderBottom: '1px solid #223B59', pb: sCell?8:16, maxWidth:1400}}
                            spacing={sCell ? 4 : 8}
                        >
                            <Grid size={{ xs: 12, sm: 12, md: 7 }}>
                                <Typography component="h1" variant="h1">
                                    {servicioEncontrado.titulo}
                                </Typography>
                            </Grid>

                            {servicioEncontrado.detalle && (
                                <Grid size={{ xs: 12, sm: 12, md: 5 }}>
                                    {Array.isArray(servicioEncontrado.detalle)
                                        ? servicioEncontrado.detalle.map((parrafo, i) => (
                                            <Typography
                                                key={i}
                                                component="p"
                                                variant={"body1"}
                                                sx={{
                                                    mb: i < servicioEncontrado.detalle.length - 1 ? 2 : 0
                                                }}
                                            >
                                                {parrafo}
                                            </Typography>
                                        ))
                                        : (
                                            <Typography
                                                component="p"
                                                variant={"body1"}
                                                sx={{  }}
                                            >
                                                {servicioEncontrado.detalle}
                                            </Typography>
                                        )
                                    }
                                </Grid>
                            )}

                            {!servicioEncontrado.detalle && servicioEncontrado.descripcion && (
                                <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                                    <Typography
                                        component="p"
                                        sx={{ fontSize: 15, color: '#223B59', lineHeight: 1.7 }}
                                    >
                                        {servicioEncontrado.descripcion}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>

                        {/* ── SUBSERVICIOS ── */}
                        {servicioEncontrado.subservicios && servicioEncontrado.subservicios.length > 0 && (
                            <Grid container size={{ xs: 12 }} spacing={4} sx={{ mb: sCell?8:16, pt:sCell?8:16, maxWidth:1400 }}>
                                {servicioEncontrado.subservicios.map((sub, idx) => (
                                    <Grid
                                        key={idx}
                                        container
                                        direction="column"
                                        size={{ xs: 12, sm: 6, md: 4 }}
                                    >
                                        <Typography
                                            component="h2"
                                            variant="h3"
                                            sx={{ }}
                                        >
                                            {sub.titulo}
                                        </Typography>

                                        <Typography
                                            component="p"
                                            variant="body1"
                                            sx={{ }}
                                        >
                                            {sub.descripcion}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        )}

                        {/* ── PROCESO ── */}
                        {servicioEncontrado.proceso && servicioEncontrado.proceso.length > 0 && (
                            <Grid container size={{ xs: 12 }} sx={{ mb: sCell?8:16, borderTop: '1px solid #223B59', pt: sCell?8:16, maxWidth:1400 }}>
                                <Grid size={{ xs: 12 }} sx={{ mb: 8 }}>
                                    <Typography
                                        component="h2"
                                        variant="h2"
                                        sx={{  }}
                                    >
                                        ¿Cómo trabajamos?
                                    </Typography>
                                </Grid>

                                <Grid container size={{ xs: 12 }} spacing={2}>
                                    {servicioEncontrado.proceso.map((paso, idx) => (
                                        <Grid
                                            key={idx}
                                            size={{ xs: 12, sm: 6, md: 3 }}
                                            sx={{
                                                border: '1px solid #223B59',
                                                borderRadius: 2,
                                                p: 3,
                                            }}
                                        >
                                            <Typography
                                                sx={{ fontSize: 11, fontWeight: 500, color: '#223B59', opacity: 0.5, mb: 1, letterSpacing: '0.08em' }}
                                            >
                                                {paso.numero}
                                            </Typography>
                                            <Typography
                                                component="h3"
                                                variant="h3"
                                                sx={{ mb: 1, }}
                                            >
                                                {paso.titulo}
                                            </Typography>
                                            <Typography
                                                component="p"
                                                variant="body1"
                                                sx={{  }}
                                            >
                                                {paso.descripcion}
                                            </Typography>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Grid>
                        )}

                        {/* ── PREGUNTAS FRECUENTES ── */}
                        {servicioEncontrado.preguntas_frecuentes && servicioEncontrado.preguntas_frecuentes.length > 0 && (
                            <Grid container size={{ xs: 12 }} sx={{ mb: sCell?8:16, borderTop: '1px solid #223B59', pt: sCell?8:16, maxWidth:1400 }}>
                                <Grid size={{ xs: 12 }} sx={{ mb: 4 }}>
                                    <Typography
                                        component="h2"
                                        variant="h2"
                                        sx={{  }}
                                    >
                                        Preguntas frecuentes
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    {servicioEncontrado.preguntas_frecuentes.map((faq, idx) => (
                                        <Accordion
                                            key={idx}
                                            disableGutters
                                            elevation={0}
                                            sx={{
                                                borderBottom: '1px solid #223B59',
                                                background: 'transparent',
                                                '&:before': { display: 'none' },
                                            }}
                                        >
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon sx={{ color: '#223B59' }} />}
                                                sx={{ px: 0, py: 1 }}
                                            >
                                                <Typography
                                                    component="h3"
                                                    variant="h3"
                                                    sx={{ fontSize: 15, fontWeight: 600, color: '#223B59' }}
                                                >
                                                    {faq.pregunta}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ px: 0, pb: 2 }}>
                                                <Typography
                                                    component="p"
                                                    variant="body1"
                                                    sx={{ fontSize: 14, color: '#223B59', opacity: 0.75, lineHeight: 1.7 }}
                                                >
                                                    {faq.respuesta}
                                                </Typography>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Grid>
                            </Grid>
                        )}

                        {/* ── CTA ── */}
                        {servicioEncontrado.cta && (
                            <Grid
                                container
                                size={{ xs: 12 }}
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    background: '#223B59',
                                    borderRadius: 3,
                                    p: sCell ? 3 : 5,
                                    gap: 3,
                                    flexDirection: sCell ? 'column' : 'row',
                                }}
                            >
                                <Grid size={{ xs: 12, md: 8 }}>
                                    <Typography
                                        component="h2"
                                        variant="h2"
                                        sx={{ color: '#fff', mb: 4 }}
                                    >
                                        {servicioEncontrado.cta.titulo}
                                    </Typography>
                                    <Typography
                                        component="p"
                                        variant="body1"
                                        sx={{color: 'rgba(255,255,255,0.65)',}}
                                    >
                                        {servicioEncontrado.cta.descripcion}
                                    </Typography>
                                </Grid>

                                <Grid>
                                    <ButtonBase
                                        onClick={() => navigate(servicioEncontrado.cta.enlace)}
                                        sx={{
                                            background: '#fff',
                                            color: '#223B59',
                                            px: 3,
                                            py: 1.5,
                                            borderRadius: 2,
                                            fontSize: 14,
                                            fontWeight: 600,
                                            transition: '0.2s',
                                            '&:hover': { opacity: 0.85 },
                                        }}
                                    >
                                        {servicioEncontrado.cta.boton}
                                    </ButtonBase>
                                </Grid>
                            </Grid>
                        )}

                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Servicio_Enfoque;
